import { Box, Heading, Text } from '@chakra-ui/react'
import Header from '../Header'
import PageTransition from '../components/PageTransition'

const Education = (): JSX.Element => (
  <>
    <Header title="Education" subtitle="Learn more about investment strategies" />
    <PageTransition>
      <Box p={4}>
        <Heading as="h2" size="xl" mb={4}>Educational Content</Heading>
        <Text fontSize="md">This page will contain educational resources and guides on various investment topics.</Text>
      </Box>
    </PageTransition>
  </>
)

export default Education
